import { useContext } from 'react';
import { LockOrderContext } from "../context/LockOrderContext";
import { useLogger } from './useLogger';

const useBeforeNavigate = () => {
  const logger = useLogger();
  const lockOrderContext = useContext(LockOrderContext);
  const {
    warnBeforeNavigate,
    setWarnBeforeNavigate,
    setShowNavigationWarning,
    setNavigationWarningAction,
  } = lockOrderContext;

  const clearContextValues = () => {
    setShowNavigationWarning(false);
    setWarnBeforeNavigate(false);
    setNavigationWarningAction(() => {});
  }

  const close = () => {
    logger.UI.log('useBeforeNavigate - user cancelled');
    setShowNavigationWarning(false);
    setNavigationWarningAction(() => {});
  }

  const act = () => {
    logger.UI.log('useBeforeNavigate - user confirmed');
    lockOrderContext.navigationWarningAction()
    clearContextValues()
  }

  const checkForChanges = (action: () => void, source: string = '') => {
    if (warnBeforeNavigate) {
      logger.UI.log('useBeforeNavigate - show confirmation: ', source);
      setShowNavigationWarning(true);
      setNavigationWarningAction(() => action);
    } else {
      logger.UI.log('useBeforeNavigate - no confirmation needed: ', source);
      clearContextValues();
      action();
    }
  };

  return { checkForChanges, clearContextValues, act, close };
};

export default useBeforeNavigate;